import React from "react";

const ItContractpage=React.lazy(()=>import('./ItContractpage'));
const WebAppPage=React.lazy(()=>import('./WebAppPage'));
const MobileApp=React.lazy(()=>import('./MobileApp'));
const CloudDevopsPage=React.lazy(()=>import('./CloudDevopsPage'));
const DedicatedTeams=React.lazy(()=>import('./DedicatedTeams'));
const QaTestingPage=React.lazy(()=>import('./QaTestingPage'));
const ServerlessAppPage=React.lazy(()=>import('./ServerlessAppPage'));
const Servicepage=React.lazy(()=>import('./Servicepage'));
const NewProductDevelopment=React.lazy(()=>import('./NewProductDevelopment'));
const DigitalTransformation=React.lazy(()=>import('./DigitalTransformation'));
const AiConsultation=React.lazy(()=>import('./AiConsultation'));

export {
  ItContractpage,
  WebAppPage,
  MobileApp,
  CloudDevopsPage,
  DedicatedTeams,
  QaTestingPage,
  ServerlessAppPage,
  Servicepage,
  NewProductDevelopment,
  DigitalTransformation,
  AiConsultation
};